import { CLEAR_PAGE } from '../base/types';
import {
  FETCH_PSYCHOLOGIST,
  UPDATE_PSYCHOLOGIST,
  FETCH_PSYCHOLOGIST_FEEDBACKS,
  FETCH_PSYCHOLOGIST_NEWS,
} from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  isAuth: false,
};

const psychologistsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PSYCHOLOGIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${UPDATE_PSYCHOLOGIST}_FULFILLED`:
    case `${FETCH_PSYCHOLOGIST}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_PSYCHOLOGIST}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_PSYCHOLOGIST_FEEDBACKS}_FULFILLED`:
      return {
        ...state,
        feedbacks: payload,
      };
    case `${FETCH_PSYCHOLOGIST_NEWS}_FULFILLED`:
      return {
        ...state,
        news: payload,
      };

    case CLEAR_PAGE:
      return payload === 'psychologist' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default psychologistsReducer;
